import React from "react";
import { ArrowUpRightIcon, MapPinIcon } from "lucide-react";
import { properties } from "../data/properties";
export function RealEstate() {
  return <section id="actualites" className="w-full bg-white py-24 lg:py-32" data-id="element-185" data-mp="3otk7h5521zri">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-186" data-mp="3jzfy6f8bhfn9">
        <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-187" data-mp="3f1w8mj665gg0">
          <div className="lg:col-span-7" data-id="element-188" data-mp="3ezjuyi7g1s8r">
            <h2 className="font-serif text-4xl font-medium text-ink lg:text-5xl" data-id="element-189" data-mp="3a32z11u069l4">Immobilier d'investissement</h2>
            <p className="mt-4 max-w-xl text-lg text-muted" data-id="element-190" data-mp="352f6ucu1fmpb">
              Investissez tout en profitant d'avantages fiscaux significatifs : transformez une partie de vos impôts
              en capital et renforcez la protection de vos proches.
            </p>
          </div>
          <p className="font-serif text-2xl italic text-brand lg:col-span-5 lg:text-right" data-id="element-191" data-mp="zb1q8awcvhpw">Nos coups de cœur</p>
        </div>

        <div className="mt-14 grid gap-10 md:grid-cols-2" data-id="element-192" data-mp="ucgm40dzgdw6">
          {properties.map(p => <article key={p.id} className="group flex flex-col" data-id="element-193" data-mp="djr4ial3oyuo">
              <a href="#contact" className="block overflow-hidden rounded-2xl" aria-label={`Découvrir ${p.name}`} data-id="element-194" data-mp="ijncsm0tzcg1">
                <img src={p.image} alt={p.name} className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-195" data-mp="4kw0n55j40uj" />
              </a>
              <div className="mt-6 flex items-center justify-between gap-4" data-id="element-196" data-mp="xaw91dz8nw25">
                <p className="flex items-center gap-1.5 text-sm text-muted" data-id="element-197" data-mp="119va2nhun8ob">
                  <MapPinIcon className="h-4 w-4" data-id="element-198" data-mp="njrqk4actt2k" />
                  {p.location}
                </p>
                <span className="rounded-full bg-brand-light px-3 py-1 text-xs font-medium text-brand" data-id="element-199" data-mp="sh1gdl1no6qx">{p.tag}</span>
              </div>
              <h3 className="mt-3 font-serif text-3xl font-medium text-ink" data-id="element-200" data-mp="1g6ch52j0a152">{p.name}</h3>
              <p className="mt-3 leading-relaxed text-muted" data-id="element-201" data-mp="1kzxcemt7sh0k">{p.description}</p>
              <ul className="mt-5 flex flex-wrap gap-x-5 gap-y-1 text-sm text-ink" data-id="element-202" data-mp="1ut1i78swomdk">
                {p.facts.map(f => <li key={f} data-id="element-203" data-mp="1pw19eq4o95ir">· {f}</li>)}
              </ul>
              <a href="#contact" className="mt-auto inline-flex w-fit items-center gap-2 border-b border-ink/30 pb-1 pt-8 text-sm font-semibold text-ink transition-colors duration-150 hover:border-brand hover:text-brand" data-id="element-204" data-mp="1kuvh2texbk9r">
                Demander la plaquette
                <ArrowUpRightIcon className="h-4 w-4" data-id="element-205" data-mp="17377aws5d7vy" />
              </a>
            </article>)}
        </div>
      </div>
    </section>;
}